import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Component } from "react";
import { Button } from "react-bootstrap";
import { InventoryConfirmation } from "../modal/inventory-confirmation.component";
import { ACTION_TYPES, MAX_LENGTH } from "../../../../constants/external-constants";
import { addPlanDetailActions } from "../../../../store/external/inventory/details-view/add-plan-details.reducer";
import Translation from "../../../common/translation/translation.component";
import { TRANSLATIONS } from '../../../../utils/constant.utils';
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import CustomSearchableSelectWrapper from "../../../common/custom-form/custom-searchable-select-wrapper.component";
import CustomSearchableSelect from "../../../common/custom-form/custom-searchable-select.component";
import TableWithButton from "../../../common/details-table/table-with-button.component";
import { NotificationModal } from "../../../common/modal/notification-modal.component";
import { CustomDropdown } from "../../../common/custom-form/custom-dropdown.component";
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";
import { CONFIRMATION_VALUE } from "../../../../utils/constant.utils";

class AddPlanDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeDropdown: false,
            showTable: false,
            enableAddBtn: true,
            inventorycircuit_plans_Id: null,
            showNotif: false,
            showModal: false,
            notifTitle: '',
            isUpdate: false,
            isNewPlan: false,
            hasSelectedNewPlan: false,
            originalPlanComponents: [],
        }
    }

    loadPlanDetails(planId, useOriginalComponent) {
        this.props.getInventoryCircuitPlanComponents(planId, (useOriginalComponent && this.props.isOriginalComponent) ? true : useOriginalComponent);

        this.setState({
            isUpdate: this.updatePlan(planId)
        });
    }

    ShowTable() {
        this.props.showDetails(true)
    }

    clearField(){
        //please change the actual state of your component
        this.setState({ filterSelected: "", showTable:false })
        this.searchableChange(0)
    }

    componentDidMount() {;
        const { getInventoryCircuitPlanDetails, getInventoryCircuitPlanComponents, circuitId, planId,
            getInventoryPlanTypesByVendorByCircuitType, circuitTypeId, vendorId } = this.props;
        const { hasSelectedNewPlan } = this.state;
        getInventoryPlanTypesByVendorByCircuitType(vendorId, circuitTypeId);
        if (circuitId !== 0 && circuitId !== undefined && circuitId !== null && planId !== 0 && planId !== undefined && planId !== null && !hasSelectedNewPlan) {
            getInventoryCircuitPlanComponents(planId, true);
        }
        else {
            getInventoryCircuitPlanComponents(planId, false);
        }
        getInventoryCircuitPlanDetails(circuitId);
    }

    componentWillUnmount() {
        const { resetPlanDetails } = this.props;
        this.clearField();
        resetPlanDetails();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isTogglePlan !== this.props.isTogglePlan) {
            // Close the dropdown if isTogglePlan changes
            this.setState({ activeDropdown: false });
        }
        if (prevProps.isOriginalComponent !== this.props.isOriginalComponent) {
            this.setState({ hasSelectedNewPlan: this.props.isOriginalComponent ? false : true });
        }
    }
    cancelBtn() {
        this.setState({ enableAddBtn: false })
        const { inventoryCicuitPlanDetailsForm } = this.props;
        const { isNewPlan } = this.state;

        if (!inventoryCicuitPlanDetailsForm.PlanId || isNewPlan) {
            this.clearField()
        }

        this.isActiveDropDownState();
        if(this.props.titleBtn===ACTION_TYPES.Update) {
            this.props.toggleDropdown()
            this.props.showDetails(true)
            this.props.enableUpdate(false)

        }
    }

    onChangeInventoryCircuitPlanSelect = (indicator, item) => {
        const { getInventoryCircuitPlanComponents, inventoryCircuitPlanDetails } = this.props;

        if (item !== inventoryCircuitPlanDetails.PlanId) {
            getInventoryCircuitPlanComponents(item);
        }
        
        this.setState({
            enableUpdate: true,

        });
    }

    transformOptions = (option) => {
        // use to transform data structure aligned to custom select dropdown
        let newOption;
        newOption = option?.map(elem => {
            return {
                FilterId: elem.Key || elem.PlanId,
                FilterName: elem.Value || elem.PlanName,
                FilterValue: elem.Value || elem.PlanName,
            }
        })
        return newOption;
    }

    searchableChange(event, model) {
        this.loadPlanDetails(event, false);
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];

        return TRANSLATIONS[locale][key];
    }

    onRowClickPlanDetails = (index) => {
        const { planDetails } = this.props.inventoryCircuitPlanDetails;
        const { hasSelectedNewPlan, originalPlanComponents } = this.state;

        const planId = planDetails.datatable[0]?.dataItem[0]?.PlanId;

        if (!planId) return;

        if (hasSelectedNewPlan) {
            this.loadPlanDetails(planId, false);
        } else {
            this.loadPlanDetails(planId, true);

            if (originalPlanComponents.length === 0) {
                this.setState({
                    originalPlanComponents: this.props.inventoryCircuitPlanDetails.planComponents?.Data?.Items || []
                });
            }
        }
        this.isActiveDropDownState();

        this.setState({
            isUpdate: true
        });

    };

    isActiveDropDownState = () => {
       this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
    }

    toggleActiveState = () => {
        this.setState({ isUpdate: false });
        if (this.hasExistingPlan()) {
            this.setState({ activeDropdown: false });
        }
        else{
            this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown, isNewPlan: true }));
        }
    }

    deletePlanDetails = (index) => {
        this.props.deletePlanDetails();
        this.props.handleChangesStatus('planDetailsChange', true, "0.00", true);
        this.clearField();
        this.setState({ activeDropdown: false });
    }

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    }
    handleOpenNotif = () => {
        this.setState({
            showNotif: true,
            notifTitle: 'Delete'
        });
    }

    hasExistingPlan = () => {
        const { planDetails } = this.props.inventoryCircuitPlanDetails;
        let planExist = false;
        if (planDetails.datatable.length > 0) {
            planExist = planDetails.datatable[0].dataItem.length > 0;
        }

        return planExist;
    }

    updatePlan = (planId) => {
        const { planDetails } = this.props.inventoryCircuitPlanDetails;
        let update = false;

        if (planDetails.datatable.length > 0) {
            const dataItem = planDetails.datatable[0].dataItem;
            if (dataItem.length > 0) {
                update = dataItem.findIndex(r => r?.PlanId == planId) != -1;             
            }
        }

        return update;
    }

    addPlanDetails = () => {
        this.props.addPlanDetails();
        this.setState({
            activeDropdown: false
        });
    }

    onClickUpdate = () => {
        this.setState({
            showModal: true,
            notifTitle: 'Update',
            isUpdate: true
        })
    }

    onClickAdd = () =>{

        this.setState({
            showModal: true,
            notifTitle: 'Add'
        })
    }

    isUpdateBtnDisable = (state, form, circuitPlans) => {
        const { isUpdate, originalPlanComponents, hasSelectedNewPlan } = this.state;
        const { PlanId } = form;
        var componentsHasChange = hasSelectedNewPlan ? false : ((this.props.planId == PlanId ) ? this.props.inventoryCircuitPlanDetails.planComponents?.Data?.Items.length !== originalPlanComponents.length : true);
        if (isUpdate) {           
                const isFormValid = PlanId;
                const hasChange = circuitPlans?.PlanId !== Number(PlanId);
                if(!PlanId) {
                    return true
                }
                return isFormValid && hasChange && !componentsHasChange;
        }

        return false
    }

    handleConfirmationModal = (buttonType) =>{
        if (buttonType === CONFIRMATION_VALUE.Ok){
            this.addPlanDetails();
            const mrc = this.props.inventoryCircuitPlanDetails.planComponents?.Data?.Items?.reduce((sum, item) => sum + (item.ComponentCost || 0), 0);
            this.props.handleChangesStatus('planDetailsChange', true, mrc, true);
            this.setState( prev => ({
                showModal: !prev.showModal,
                showNotif: false,
                isUpdate: true,
                hasSelectedNewPlan: true
            }))
        }else{
            this.setState({
                showModal: false,
                isUpdate: false
            });
        }
    }

    render() {
        const {
            planDetails,
            circuitPlans,
            planComponents,
        } = this.props.inventoryCircuitPlanDetails;
        const {
            inventoryCicuitPlanDetailsForm,
            hasPendingApproval,
        } = this.props;

        const { isUpdate } = this.state

        const hasExistingPlan = this.hasExistingPlan();
        const enableButton = inventoryCicuitPlanDetailsForm.PlanId;
        const sectionTitle = hasExistingPlan ? this.toLocaleLanguage('plan_details') : this.toLocaleLanguage('add_plan_details');

        return (
            <>
                <NotificationModal
                    show={this.state.showNotif}
                    title={'Success'}
                    message={`Plan details ${this.state.notifTitle} successfully!`}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />

                <CustomDropdown activeDropdown={this.state.activeDropdown} toggleActiveState={this.toggleActiveState} label={sectionTitle}>
                    <div className="add-plan-container">
                        <CustomSearchableSelectWrapper
                            label={this.toLocaleLanguage("plan_name_capital")}
                            options={circuitPlans}
                            selected={inventoryCicuitPlanDetailsForm.PlanId}
                            fieldProp='inventoryCicuitPlanDetailsForm.PlanId'
                            onChange={(e) => this.searchableChange(e, "inventoryCicuitPlanDetailsForm.PlanId")}
                            placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                            tagName='PlanName'
                            optionLabelKey={{
                                Key: 'PlanId',
                                Value: 'PlanNameOrderable',
                                Label: 'PlanNameOrderable',
                            }}
                            maxLength={MAX_LENGTH.limit_255}
                        />
                        { !inventoryCicuitPlanDetailsForm.PlanId || planComponents.Data.Items.length > 0 &&
                            <>
                                <TablePagination
                                    columns={planComponents.Headers}
                                    pageList={planComponents.Data.Items}
                                    haveExternalDeleteBtn={this.props.haveEditRemoveBtn}
                                    isNotSortable={true}
                                    paginationHidden={true}
                                />
                            </>
                        }

                        <div className="add-button-container custom-add-button mb-3">
                            <div className="btn-tooltiptext">
                                <Button onClick={this.cancelBtn.bind(this)} className="btn-custom-violet-hover-outline">Cancel</Button>
                                <span className="tooltip-text">Cancel adding plan details</span>
                            </div>


                            <ConfirmationNotificationModal
                                show={this.state.showModal}
                                message={`Are you sure you want to ${this.state.isUpdate ? `${ACTION_TYPES.Update.toLowerCase()}` : `${ACTION_TYPES.Add.toLowerCase()}`}?`}
                                title={this.state.notifTitle}
                                handleModal={this.handleConfirmationModal}
                                className={'comment-notification-modal'}
                                customClass={'comment-notification-modal modal-text-bold'}
                            />
                            <div className={'btn-tooltiptext'}>
                                <Button
                                    className="btn-add"
                                    disabled={(this.props.isReadOnly || this.props.isReadAndExtractOnly) ? true : hasPendingApproval ? hasPendingApproval :
                                        (isUpdate ? this.isUpdateBtnDisable(this.state, inventoryCicuitPlanDetailsForm, circuitPlans) : !enableButton)}
                                    onClick={planDetails?.datatable[0]?.dataItem?.length === 0 ? this.onClickAdd : this.onClickUpdate}>{planDetails?.datatable[0]?.dataItem?.length === 0 ? `${ACTION_TYPES.Add}` : `${ACTION_TYPES.Update}`}
                                </Button>
                                <span className="tooltip-text">{planDetails?.datatable[0]?.dataItem?.length === 0 ? `${ACTION_TYPES.Add}` : `${ACTION_TYPES.Update}`} Plan Details</span>
                            </div>
                        </div>

                    </div> 
                </CustomDropdown>
                {
                    hasExistingPlan &&
                    <div className="details-table-container add-sim-container">
                        <TableWithButton
                            classNameWrapper="table-details-wrapper table-clickable"
                            datatable={planDetails.datatable}
                            haveExternalDeleteBtn={this.props.IsReadOnly ? false : (this.props.isReadAndExtractOnly ? false : (this.props.isReadAndWrite? true: false))}
                            deleteAction={this.deletePlanDetails}
                            rowClickAction={this.onRowClickPlanDetails}
                            updateNotifTitle={this.updateNotifTitle}
                            handleOpenNotif={this.handleOpenNotif}
                        />  
                    </div>
                }
            </>
        )
    }
};
export default connect(
    state => {
        const { inventoryCircuitPlanDetails, translation } = state;
        const { inventoryCicuitPlanDetailsForm } = state.form;
        return {
            inventoryCircuitPlanDetails
            , inventoryCicuitPlanDetailsForm
            , ...translation
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, addPlanDetailActions),
        dispatch
    )
)(AddPlanDetails);